module.exports = __webpack_public_path__ + "img/sun-bright.451fac95.svg";